export const CLIENT_NOTIFICATIONS_QUERY_KEY = 'clientNotifications'
export const NOTIFICATIONS_QUERY_KEY = 'notifications'
export const DONE_NOTIFICATIONS_QUERY_KEY = 'doneNotifications'
export const NOTIFICATIONS_AGGREGATE_QUERY_KEY = 'notificationsAggregate'
